import { ContentType } from "@/api/scode/scode_params";
import loadingPng from "@/base64";
import PosterSwipePro from "@/components/poster-swiper/pro";
import VerticalScrollview from "@/components/vertical-scrollview";
import { platform } from "@/utils/platform";
import { pxtorem } from "@/utils/pxtorem";
import useNavigation from "@/utils/useNavigate";
import { wechatSdkInit } from "@/utils/wx-share";
import { Image } from "antd-mobile";
import React, { useEffect, useState } from "react";
import BrandModule from "./components/BrandModule";
import BrandPreview from "./components/BrandPreview";
import { useRmsActivity } from "./hooks/useRmsActivity";
import { useRmsShare } from "./hooks/useRmsShare";
import styles from "./index.module.less";

// 顶部导航栏组件
const TopHeader: React.FC<{
  goBack: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  goHome: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  goCart: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}> = ({ goBack, goHome, goCart }) => {
  if (platform.isApp) {
    return <div className={styles.topEmpty}></div>;
  }
  return (
    <div className={styles.topNavigation}>
      {platform.isH5 && (
        <div className={styles.leftBox}>
          <img
            onClick={goBack}
            className={styles.backIcon}
            src="https://akim-oss.aikucun.com/b1d5781111d84f7b3fe45a0852e59758cd7a87e5_1699586824224_62.png"
          />
          <div onClick={goHome} className={styles.homeBox} id="navigation-home">
            <img
              className={styles.homeIcon}
              src="https://akim-oss.aikucun.com/17ba0791499db908433b80f37c5fbc89b870084b_1699586824394_34.png"
            />
          </div>
        </div>
      )}
      <div className={styles.midBox}></div>
      <div className={styles.rightBox}>
        <img
          onClick={goCart}
          className={styles.cartIcon}
          src="https://akim-oss.aikucun.com/e847b090ce2259a85e1b4a1aaa4f79d5aa3b03da_1750669027612_16.png"
        />
      </div>
    </div>
  );
};

// 加载组件
const LoadingView: React.FC = () => (
  <div className={styles.loading}>
    <Image src={loadingPng} width={pxtorem(30)}></Image>
  </div>
);

const RmsActivity: React.FC = () => {
  const control = useRmsActivity();
  const { track, rmsData, commonContext } = control;
  const { navigate2H5 } = useNavigation();
  const { swiperControl, productControl, handleShareProduct } = useRmsShare({
    rmsShare: {
      contentType: ContentType.COLLECT_MARKET,
      contentId: control.planId || "",
      marketName: control.pageName,
    },
    dependencies: [rmsData],
  });

  useEffect(() => {
    document.title = "重点关注品牌";
    control.initNavApp();

    if (track.track) {
      track.track("$pageview", {
        page_name: control.pageName,
        content_id: control.planId || "",
        previous_page_name: control.search.get("page_name") || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickBtn = () => {
    swiperControl.open();

    if (track.track) {
      track.track("resource_click", {
        page_name: control.pageName,
        content_id: control.planId || "",
        previous_page_name: control.search.get("page_name") || "",
        resource_type: "底部操作",
        resource_name: commonContext.currentRole === "C" ? "分享会场" : "转发赚钱",
        btn_text: commonContext.currentRole === "C" ? "分享会场" : "转发赚钱",
      });
    }
  };

  const mainContent = () => {
    if (control.loading) {
      return <LoadingView />;
    }
    return (
      <>
        {rmsData?.brandInfoList?.length && (
          <BrandPreview
            title={rmsData?.title}
            brandInfoList={rmsData?.brandInfoList}
            control={control}
          />
        )}
        {rmsData?.moduleInfoList?.map((item, index) => (
          <BrandModule
            key={index}
            moduleInfo={item}
            currentRole={commonContext.currentRole}
            handleShareProduct={handleShareProduct}
            control={control}
          />
        ))}
        <div className={styles.footer}>
          <div className={styles.longBtn} onClick={onClickBtn}>
            {commonContext.currentRole === "C" ? (
              <img
                className={styles.share}
                src="https://akim-oss.aikucun.com/f4f0a5c6ad78c311babb4817d2a3086f28e690ad_1750124011242_65.png"
              />
            ) : (
              <img
                className={styles.money}
                src="https://akim-oss.aikucun.com/724d1d68af4786a65e731815ed0cd75fabd6c8b2_1750658293788_1.png"
              />
            )}
            <span>{commonContext.currentRole === "C" ? "分享会场" : "转发赚钱"}</span>
          </div>
        </div>
      </>
    );
  };
  return (
    <VerticalScrollview className={styles.RmsActivity}>
      {/* 顶部导航 */}
      <TopHeader goBack={control.goBack} goHome={control.goHome} goCart={control.goCart} />
      {mainContent()}
      {/* 会场分享 */}
      <PosterSwipePro {...swiperControl.props} />
      {/* 商品分享 */}
      <PosterSwipePro {...productControl.props} />
    </VerticalScrollview>
  );
};

export default RmsActivity;
